import React, { useRef } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { FlowchartHeader } from "./FlowchartHeader";
import { FlowchartCanvas } from "./FlowchartCanvas";
import { useFlowchartExport } from "./hooks/useFlowchartExport";
import type { FlowchartData } from "@/lib/chat/parseFlowchartBlock";

interface FlowchartModalProps {
  open: boolean;
  onClose: () => void;
  data: FlowchartData;
}

export const FlowchartModal: React.FC<FlowchartModalProps> = ({
  open,
  onClose,
  data,
}) => {
  const canvasRef = useRef<HTMLDivElement>(null);
  const { exportPNG } = useFlowchartExport(canvasRef, data.title);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="flex h-[90vh] w-[95vw] max-w-none flex-col gap-0 p-0 sm:rounded-2xl [&>button:last-child]:hidden">
        <FlowchartHeader
          title={data.title}
          mode="expanded"
          onDownload={exportPNG}
          onToggleExpand={onClose}
        />
        <div ref={canvasRef} className="flex-1 overflow-auto bg-muted/20">
          <FlowchartCanvas data={data} maxHeight="none" />
        </div>
      </DialogContent>
    </Dialog>
  );
};
